<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-8 col-xl-8">
        <!-- <object v-if="opportunity.sign_request && opportunity.sign_request.signed_pdf_data" v-bind:data="pdfData" type="application/pdf" width="100%" height="1200px"></object> -->
        <!-- <div v-else> -->
        <div v-if="html" v-html="html" class="document-preview"></div>
        <!-- </div> -->
      </div>

      <div class="col-4" style="max-width: 700px" v-if="signRequest.signable">
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">QA Approval</h4>
          </div>

          <div class="card-body">
            <div v-if="signRequest.signable.warnings && signRequest.signable.warnings.length" role="alert" class="alert alert-warning">
              <div class="alert-content">
                <h2 class="alert-heading d-inline-block">Warning!</h2> <br/>This document contains the following issues:
                <ul>
                  <li v-for="(warning, index) in signRequest.signable.warnings" :key="index">{{ warning }}</li>
                </ul>
              </div>
            </div>

            <div v-if="!signRequest.signable.approved_at" class="mb-3">
              <label class="control-label">Approver</label>
              <div class="input-group mb-3">
                <span class="input-group-text">
                  <i class="fal fa-fw fa-user"></i>
                </span>
                <multiselect
                  :show-labels="false"
                  :value="signRequest.signable.approver"
                  v-model="approver"
                  :options="users"
                  label="name"
                  track-by="id"
                  placeholder="Select Approver"
                  v-validate="'required'"
                  data-vv-name="user"
                ></multiselect>

              </div>
              <c-button variant="success" @click="handleSendForApproval">{{ signRequest.signable.approver ? 'Change Approver' : 'Send for Approval' }}</c-button>
            </div>

            <div v-if="canApproveDocument">
              <hr />

              <c-button variant="primary" @click="confirmApproveDocument">Approve Document</c-button>
            </div>

            <div v-if="signRequest.signable.approved_at">
              <p>Approved By: </p>
              <p>{{ signRequest.signable.approver ? signRequest.signable.approver.name : 'Unknown (deleted)' }} at {{ signRequest.signable.approved_at | moment('DD/MM/YYYY h:mm') }}</p>

              <c-button v-if="canUnapproveDocument" variant="danger" @click="confirmUnapproveDocument">Unapprove Document</c-button>
            </div>
          </div>
        </div>

        <div class="card" v-if="documentCanBeSent">
          <div class="card-header">
            <h4 class="card-header-title">Send Email</h4>
          </div>

          <div class="card-body">
            <p>
              To: {{ signRequest.signable.contact.name }},
              {{ signRequest.signable.contact.email }}
            </p>
            <p>
              From: {{ signRequest.signable.user.name }},
              {{ signRequest.signable.user.email }}
            </p>
            <h4>Message:</h4>
            <p>Hi {{ signRequest.signable.contact.first_name }},</p>

            <wysiwyg-inline :content="message" :save="saveHtml" v-if="message"></wysiwyg-inline>

            <p>Kind regards,</p>
            <p>{{ signRequest.signable.user.name }}</p>
          </div>

          <div class="card-footer text-right">
            <c-button variant="success" @click="confirmSendEmail">Send</c-button>
            <c-button variant="success" @click="confirmSendEmailRemider" style="margin-left: 20px;">Send Reminder</c-button>
          </div>
        </div>

        <div v-if="signRequest.signable.status == 'Signed'" class="card">
          <div class="card-body">
            <a
              type="button"
              class="btn btn-primary"
              style="color: #fff"
              v-on:click="getPDFDocument()"
              target="_blank"
              v-if="signRequest.signable.status == 'Signed'"
            >
              <i class="far fa-download mr-2"></i>
              Download Signed Copy
            </a>
          </div>
        </div>

        <div v-if="documentCanBeSent" class="card">
          <div class="card-body">
            <div>
              <div class="row">
                <div class="col-12">
                  <p>Generate Sign link or update document.</p>
                  <c-button variant="primary" @click="generateLink">
                    Generate Link
                  </c-button>
                </div>
              </div>

              <div class="row mt-3" v-if="signRequest.sign_request_id">
                <div class="col-12">
                  <div class="form-group form-group-material">
                    <label style="cursor: pointer" class="control-label" v-on:click="copyToClipboard()">
                      <i class="fas fa-copy"></i>
                      &nbsp;Sign Link
                    </label>
                    <input name="name" v-model="signRequest.sign_url" type="text" class="form-control" id="sign_url" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">Actions</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <p>Download DRAFT PDF.</p>
                <c-button variant="outline-primary" @click="getPDFDocument">Download Draft</c-button>
              </div>
            </div>

            <hr v-if="documentCanBeSent" />

            <div v-if="documentCanBeSent" class="row mt-3">
              <div class="col-12">
                <small>Manual Sign. Note: This will send an email to the client</small>
                <div class="form-group form-group-material">
                  <input type="file" class="form-control" id="file" ref="file" v-on:change="handleFileUpload()" />
                </div>
                <c-button class="mt-3" variant="secondary" @click="manualSign">Manual Sign</c-button>
              </div>
            </div>

            <div class="mt-5" v-show="signRequest.sign_request_id">
              <hr />
              <p>
                Remove access to proposal. If this signing request is resent a new URL link will be set.
              </p>
              <c-button variant="danger" @click="confirmWithdraw">
                Withdraw Signing Request
              </c-button>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body pb-0">
            <div class="row">
              <div class="col d-flex align-items-center">
                <h2 class="card-title mb-0">Events</h2>
              </div>
            </div>
          </div>
          <ul class="list-data no-links">
            <li class="data-heading d-none d-lg-block">
              <div class="row">
                <div class="col-4">Type</div>
                <div class="col-4">IP</div>
                <div class="col-4">Date</div>
              </div>
            </li>
            <li v-for="event in signRequest.sortedEvents" :key="event.id">
              <div class="row">
                <div class="col-4">
                  <p class="no-truncate">
                    <span class="data-label d-lg-none">Type:</span>
                    <span v-if="event.action">{{ event.action }}</span>
                    <span v-if="event.name">{{ event.old_value }} -> {{ event.new_value }}</span>
                  </p>
                </div>
                <div class="col-4">
                  <p>
                    <span class="data-label d-lg-none">IP:</span>
                    <span v-if="event.action">{{ event.ip }}</span>
                    <span v-if="event.name">{{ event.name }}</span>
                  </p>
                </div>
                <div class="col-4">
                  <p class="no-truncate">
                    <span class="data-label d-lg-none">Date:</span>
                    {{ event.created_at | moment('DD/MM/YYYY h:mm') }}
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="!signRequest.sortedEvents.length" class="mt-3">
            <p span="3" class="text-center">No Events.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.document-preview {
  padding-top: 0;
}
</style>

<script>
import { http, notify } from 'utils'
import { WysiwygInline } from 'components/form/input'
import { mapState, mapActions, mapGetters } from 'vuex'

import LaddaButton from 'components/form/input/ladda-button.vue'

export default {
  components: {
    WysiwygInline,
    LaddaButton,
  },
  data: function() {
    return {
      html: null,
      loaded: false,
      quoteGenerating: false,
      message: 'Please find below link to Document.',
      manualSignFile: null,
      approver: null
    }
  },
  computed: {
    ...mapState('users', ['users']),
    ...mapState('signRequest', { signRequest: 'single' }),

    documentCanBeSent() {
      return this.signRequest.signable.approved_at && this.signRequest.signable.status != 'Signed'
    },

    canApproveDocument() {
      return this.signRequest.signable.approver_id === this.$user.id && !this.signRequest.signable.approved_at
    },

    canUnapproveDocument () {
      return this.signRequest.signable.state != 'Signed'
    }
  },
  mounted() {
    this.getUsers()

    this.getSingle(this.$route.params.sign_request_id).then(() => {
      this.approver = this.signRequest.signable.approver
      this.getQuoteHtml().then(() => {
        this.loaded = true
      })
    })
  },
  methods: {
    ...mapActions('signRequest', ['getSingle', 'updateSingle', 'approve', 'unapprove']),
    ...mapActions('signRequest', { setRequest: 'setSingle' }),
    ...mapActions('opportunity', { getOpportunity: 'getSingle', updateOpportunity: 'updateSingle' }),
    ...mapActions('users', ['getUsers']),

    async handleSendForApproval(approver) {
      try {
        const response = await this.updateSingle({
          id: this.signRequest.id,
          payload: { approver_id: this.approver.id },
        })

        this.$emit('refresh')
        notify.success('Successfully sent for approval')

      } catch (e) {
        if (e.response.status === 400) {
          notify.error(e.response.data.message)
        }
      }
    },

    async confirmApproveDocument() {
      return this.$swal({
        title: 'Approve Document',
        html:
          'Are you sure you want to approve this document to be sent? This will send a notification to the owner of the document',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Approve',
      }).then(async () => {
        await this.approveDocument()
        notify.success('Document successfully approved')
      })
    },

    async confirmUnapproveDocument() {
      return this.$swal({
        title: 'Unapprove Document',
        html:
          'Are you sure you want to remove the approval for this document? This will send a notification to the approver of the document',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Unapprove',
      }).then(async () => {
        await this.unapproveDocument()
        notify.success('Document successfully unapproved')
      })
    },

    async approveDocument() {
      try {
        await this.approve({
          id: this.signRequest.id
        })

        this.$emit('refresh')
      } catch (e) {
        if (e.response.status === 400) {
          notify.error(e.response.data.message)
        }
      }
    },

    async unapproveDocument() {
      try {
        await this.unapprove({
          id: this.signRequest.id
        })
        this.$emit('refresh')
      } catch (e) {
        if (e.response.status === 400) {
          notify.error(e.response.data.message)
        }
      }
    },

    saveHtml(message) {
      this.message = message
      return new Promise(() => {})
    },
    confirmSendEmail() {
      return this.$swal({
        title: 'Send Email',
        html: 'Are you sure you want to email the contact?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Send Email',
      }).then(() => {
        return this.sendForSigning()
      })
    },
    confirmSendEmailRemider() {

      http
        .get('/sign-requests/' + this.signRequest.id + '/getReminderEmail')
        .then(response => {
            return this.$swal({
            title: 'Send Email Reminder',
            width: 1080,
            height:1024,
            html: '<iframe style="width:1024px;height:800px;" src=data:text/html;charset=utf-8,'+escape(response.data)+'></iframe>',
            showCancelButton: true,
            confirmButtonText: 'Send Email',
          }).then(() => {
            return this.sendReminderEmail()
          })
        })
        .catch(function() {
          //reject();
        })

      
    },
    confirmWithdraw() {
      return this.$swal({
        title: 'Withdraw Signing Request',
        html: 'Are you sure you want to withdraw this signing request?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Withdraw',
      }).then(() => {
        return this.withdraw()
      })
    },
    getQuoteHtml() {
      return http
        .get('/sign-requests/' + this.signRequest.id + '/html-preview')
        .then(response => {
          this.html = response.data
        })
        .catch(function() {
          //reject();
        })
    },
    getPDFDocument() {
      var uri = 'download'

      if (this.signRequest.signable.status != 'Signed') uri = 'downloadDraft'

      return http
        .get('/sign-requests/' + this.signRequest.id + '/' + uri, {
          responseType: 'arraybuffer',
        })
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.signRequest.signable.formatted_name + '.pdf'
          link.click()
        })
    },
    manualSign() {
      let formData = new FormData()
      formData.append('pdf', this.manualSignFile)
      formData.append('user_agent', 'manual')
      formData.append('message', 'manually signed')
      formData.append('ip', '')
      formData.append('_method', 'put') //PUT + multipart form request + php = no

      return http
        .post('/sign-requests/' + this.signRequest.id + '/manualSign', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(response => {
          this.setRequest(response.data)
          this.getOpportunity(this.signRequest.signable_id).then(() => {
            notify.success('Successfully signed request.')
          })
        })
        .catch(error => {
          if (error.response.status == 422) {
            let message = 'Form validation failed:<br>'

            if (error.response.data && error.response.data.errors) {
              Object.keys(error.response.data.errors).forEach(e => {
                message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
              })
            }

            notify.error(message)
          }
        })
    },
    withdraw() {
      return http
        .delete(`/sign-request/${this.signRequest.id}/withdraw`)
        .then(response => {
          this.getSingle(this.signRequest.id).then(() => {
            notify.success('Removed from signing system')
          })
        })
        .catch(function(error) {
          if (error.response && error.response.status && error.response.status === 422) {
            notify.error('Form validation failed, please check your inputs and try again.')
          } else if (error.response) {
            notify.error('API Error: ' + error.response.status + ' <br> ' + error.response.statusText)
          }
        })
    },
    generateLink() {
      return http
        .post(`/sign-requests/${this.signRequest.id}/sendForSigning`, {
          email: false,
          message: this.message,
        })
        .then(response => {
          this.getSingle(this.signRequest.id).then(() => {
            notify.success('Link generated and sent to signing system successfully')
          })
        })
    },
    sendForSigning() {
      this.quoteGenerating = true

      return http
        .post(`/sign-requests/${this.signRequest.id}/sendForSigning`, {
          email: true,
          message: this.message,
        })
        .then(response => {
          this.getSingle(this.signRequest.id).then(() => {
            this.quoteGenerating = false
            notify.success('Link generated and sent to signing system successfully')
          })
        })
    },
    sendReminderEmail() {
      return http
        .post(`/sign-requests/${this.signRequest.id}/sendReminderEmail`, {})
        .then(response => {
          notify.success('Reminder Notification Sent')
        })
    },
    copyToClipboard() {
      var copyText = document.getElementById('sign_url')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },

    handleFileUpload() {
      this.manualSignFile = this.$refs.file.files[0]
    },
  },
}
</script>
